<template>
  <AppSection class="wrapper">
    <slot />
  </AppSection>
</template>

<style scoped>
.wrapper {
  padding-top: var(--space-9);
}
:deep(h1) {
  margin-bottom: var(--space-9);
}
:deep(h2) {
  font-size: 24px;
}
:deep(p), :deep(ol) {
  margin-bottom: var(--space-8);
}

@media (max-width: 850px) {
  .wrapper {
    padding-top: var(--space-8);
    padding-bottom: var(--space-9);
  }
  :deep(h1) {
    font-size: 24px;
    margin-bottom: var(--space-6); 
  }
  :deep(h2) {
    font-size: 20px;
  }
  :deep(.layout) {
    gap: var(--space-3) !important;
  }
  :deep(p), :deep(ol) {
    margin-bottom: var(--space-6);
  }
}
</style>